// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M4 9V3H20V9M4 9V21M4 9H9M4 21H3M4 21H9M20 9V21M20 9H15M20 21H21M20 21H15M9 9V21M9 9H15M9 21H10M15 9V21M15 21H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"dam-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 9V3H20V9V21H15V9H9V21H4V9Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 9V3H20V9M4 9V21M4 9H9M4 21H3M4 21H9M20 9V21M20 9H15M20 21H21M20 21H15M9 9V21M9 9H15M9 21H10M15 9V21M15 21H14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-2',
    ref,
    icon: element,
  },
));

Dam2Icon.displayName = 'Dam2Icon';

export default Dam2Icon;
